import * as React from 'react';
import { Experts } from 'components';
import { Dispatch, IRootState } from '../../redux/store/configureStore';
import { connect } from 'react-redux';
import { ExpertContainer } from '../ExpertContainer';

const mapDispatchToProps = (dispatch: Dispatch) => ({
    getQualifications: dispatch.qualifications.getQualifications,
    clearQualifications: () => dispatch.qualifications.setQualifications(null),
    getExperts: dispatch.experts.getExperts,
    clearExperts: dispatch.experts.clearExpertsList,
});

const mapStateToProps = (state: IRootState) => ({
    qualifications: state.qualifications.qualifications,
    expertDetails: state.expert.personalData,
    experts: state.experts.experts,
    ascId: state.auth.auth ? state.auth.auth.profile.attestationSubCommissionId : undefined,
});

const Container = connect(mapStateToProps, mapDispatchToProps)(Experts);

const ExpertsContainer = () => (
  <Container
    renderDetails={(id: string) => (
      <ExpertContainer expertId={id} />
    )}
  />
);

export default ExpertsContainer;
